import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect, useCallback } from 'react'
import { TeamReportHeatMap } from '../../../states/types/team'
import Chart from "react-apexcharts"
import { useParams, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Loading from '../common/Loading'

import { LangValue } from '../../../states/types/common'

import { chartOptions as initialChartOptions } from './VariablesHeatMap'

import { setPath, setUrlId } from '../../../utils/url'
import { URL } from '../../constants/url'
import { format } from '../../../utils/date'
import InfoTips from '../common/InfoTips'

interface BizPointHeatMapProps {
  isLoading: boolean | undefined
  heatMapData: TeamReportHeatMap | undefined
  month?: string | undefined
  isTeamManager: boolean | undefined
}

const BizPointHeatMap: FC<BizPointHeatMapProps> = (props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const { language } = useParams<{ language: LangValue }>()

  const {
    isLoading,
    heatMapData,
    month,
    isTeamManager,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setCharData] = useState<any>(undefined)

  useEffect(() => {
    if (!heatMapData) return
    const chartOptions = initialChartOptions
    chartOptions.xaxis.categories = heatMapData.data.label.days
    chartOptions.xaxis.labels.style.colors = heatMapData.data.label.color
    chartOptions.tooltip.x.formatter = (val: number) => val + (language === "en" ? "" : "")
    setCharData({
      height: 100 + 35 * heatMapData.data.data.length,
      options: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
        tooltip: {
          ...chartOptions.tooltip,
        },
      },
      series: heatMapData.data.data,
    })
  }, [heatMapData])

  const buildMemberReportUrl = (id: number, dateString: string) => setPath(
    `${setUrlId(URL.RISK_MEMBER_DETAIL.path, 'id', id)}?type=daily&target_date=${dateString}`,
    language,
  )

  const clickApplication = (target: HTMLElement) => {
    if (!heatMapData) return
    const memberId = heatMapData.member_ids[Number(target.getAttribute("index"))]
    let targetDate = ""
    if (month) {
      targetDate = format(`${month.slice(0, 4)}-${month.slice(-2)}-${Number(target.getAttribute("j")) + 1}`, "YYYY-MM-DD")
    } else {
      targetDate = heatMapData.data.label.days[Number(target.getAttribute("j"))]
    }
    history.push(buildMemberReportUrl(memberId, targetDate))
  }

  const applicationRef = useCallback((node: HTMLInputElement | null) => {
    if (isTeamManager === true) {
      if (!node) return
      $(node).on('click', ".apexcharts-heatmap-rect", (event) => {
        clickApplication(event.target)
      })
    }
  }, [heatMapData])

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box">
        <div style={{ textAlign: "center", paddingTop: "1em", paddingBottom: "1em" }}>
          <span style={{ fontWeight: "bold", fontSize: "24px", color: "#094E8D" }}>{t("parts.biz_point_heat_map.title")}</span>
        </div>
        <InfoTips>
          <>
            <div>
              チームメンバーの１日ごとの操作量を濃淡で示す「ヒートマップ」で表示しています
            </div>
          </>
        </InfoTips>
        <div className="box-body no-padding">
          {
            isLoading || !chartData ? (
              <Loading />
            ) : (
              <div ref={applicationRef}>
                <Chart
                  options={chartData.options}
                  type="heatmap"
                  series={chartData.series}
                  height={chartData.height}
                />
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

BizPointHeatMap.defaultProps = {
  month: undefined,
}

export default BizPointHeatMap
